import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventPageTemplate, Qrcode } from '../';
import { Box, BoxTitle } from '../../PageTemplate';
import { ImagesActions } from '../../../actions';
import './eventMainPage.scss';

class EventMainPage extends Component { 
    
    componentDidMount() {
        const {dispatch, events} = this.props;

        if(events.currentEventID) {
            dispatch(ImagesActions.getAllImages(events.currentEventID));
        }
    }

    componentDidUpdate(prevProps) {
        const {dispatch, events} = this.props;

        if(prevProps.events.currentEventID !== events.currentEventID) {
            dispatch(ImagesActions.getAllImages(events.currentEventID));
        }
    }

    counter() {
        const {images, events} = this.props;
        const imagesList = images && images.list && images.list[events.currentEventID]
        
        const count = {
            printed: 0,
            copies: 0,
            length: 0
        }

        if(!events.currentEventID || !imagesList) return count;

        count.length = imagesList.length;
        
        imagesList.forEach((item) => {
            count.printed += item.printed;
            count.copies += item.copies;
        });
        
        return count;
    }

    eventLimit() {
        const {events} = this.props;
        const event = events && events.list && events.list[events.currentEventID];
        if(!event) return 0;

        return event.maxImages.event
    }

    render() {
        const {printed, copies, length} = this.counter();
        const limit = this.eventLimit();

        return (
            <EventPageTemplate id="eventMainPage">
                <Box col="3">
                    <Qrcode/>
                </Box>
                <div className="boxGrid">
                    <Box col="2">
                        <BoxTitle icon="faImages">
                            תמונות
                        </BoxTitle>
                        <div className="counter">
                            {length}
                        </div>
                    </Box>
                    <Box col="2">
                        <BoxTitle icon="faCopy">
                            עותקים 
                        </BoxTitle>
                        <div className="counter">
                            {copies}
                        </div>
                    </Box>
                    <Box col="2">
                        <BoxTitle icon="faPrint">
                            הדפסות
                        </BoxTitle>
                        <div className="counter">
                            {printed}
                        </div>
                    </Box>
                    <Box col="2" className={limit <= copies && copies !== 0 ? 'warning' : ''}>
                        <BoxTitle icon="faExclamationCircle">
                            הגבלת עותקים
                        </BoxTitle>
                        <div className="counter">
                            {limit}
                        </div>
                    </Box>
                </div>
            </EventPageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        images: state.imagesReducer
    }
}

const EventMainPageWithRedux = connect(mapStateToProps)(EventMainPage);

export {EventMainPageWithRedux as EventMainPage};


// WEBPACK FOOTER //
// ./src/components/EventPage/main/EventMainPage.jsx